import React from 'react'
import { FormStainGrams } from './FormStainGrams';
import { Dialog } from 'primereact/dialog';

export const ModalStainGrams = (props) => {

    const {
        modal, tittle, toggle, method,
        name,
        handleInputChange, loading,closeDialogG,
        saveCreate,saveUpdateStain,saveDeleteStain
    } = props;

    return (
        <Dialog 
            header={tittle}
            visible={modal}
            onHide={closeDialogG}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
            {
                method === "create"
                    ? <FormStainGrams
                        button={"Crear"}
                        {...{ closeDialogG, loading,name, handleInputChange, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormStainGrams
                            button={"Actualizar"}
                            {...{ closeDialogG, loading,name, handleInputChange,methodAction: saveUpdateStain }} />
                        :
                        null
            }
        </Dialog>
    )
}
